
  import Vue from 'vue';
  import {isIOS, showInstallPwaPrompt} from "@/utils/common";
  import {MODAL_IDS, MODALS_LOADED} from "@/utils/modal";
  import {EVENTS} from "@/utils/events";
  import {MODAL_NAMES} from "@/store/modules/modalsSeen/actions";

  export default Vue.extend({
    name: "pwa-install-pwa-modal",
    components: {
      PwaSteps: () => import("@/components/common/PwaSteps.vue"),
    },
    mounted(): void {
      MODALS_LOADED[this.modalId] = true;
    },
    computed: {
      modalId(): string {
        return MODAL_IDS.INSTALL_PWA;
      },
      title(): string {
        return this.$t('417', {appName: this.appName});
      },
      message(): string {
        return this.$t('418', {appName: this.appName});
      },
      isIos(): boolean {
        return isIOS;
      },
      iosAppUrl(): string {
        return process.env.VUE_APP_IOS_APP_URL;
      },
      androidAppUrl(): string {
        return process.env.VUE_APP_ANDROID_APP_URL;
      },
    },
    methods: {
      onClickButton() {
        if (this.isIos) {
          if(this.iosAppUrl){
            this.openLink(this.iosAppUrl);
          }
          this.closeModal();
        } else {
          if(this.androidAppUrl){
            this.openLink(this.androidAppUrl);
            this.closeModal();
          }else{
            showInstallPwaPrompt()
              .then(response => {
                if (response === 'accepted') {
                  // Nothing to do
                }

                this.closeModal();
              })
              .catch(() => {
                this.closeModal();
              });
          }
        }
      },
      closeModal() {
        (this.$refs.modal as any).hide();
      },
      onShow() {
        this.updateModalLastSeen(MODAL_NAMES.INSTALL_PWA);
      },
      onClose() {
        this.$root.$emit(EVENTS.DEPOSIT_REMINDER_MODAL_CLOSE);
      },
    },
  });
